export function cleanEmptyValues<T>(obj: T): Partial<T> {
  const cleanedObj: Partial<T> = {};
  for (const key in obj) {
    if (obj[key] !== undefined) {
      const value = obj[key];
      if (value !== null && value !== undefined && value !== '') {
        cleanedObj[key] = value;
      }
    }
  }
  return cleanedObj;
}